import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import PortalBanner from '../PortalBanner';
import PortalBannerItem from "../PortalBanner/PortalBannerItem";
import Swiper from 'swiper';

export default class PortalBannerSlide extends Component {
  constructor(props) {
    super(props);
    this.renderPage = this.renderPage.bind(this);
    this.renderList = this.renderList.bind(this);
    this.setSwipe = this.setSwipe.bind(this);
    this.state = {
      currentIndex: 0
    }
  }

  componentWillUnmount() {
    this.swiper && this.swiper.destroy();
  }
  
  renderPage() {
    const { events } = this.props;
    const { currentIndex } = this.state;
    return (
      <div className="paging_slide" style={{ zIndex: 1 }}>
        {events.map((event, idx) =>
          <span key={idx} className={classnames('item_paging', { on: idx === currentIndex })} />
        )}
      </div>
    );
  }

  setSwipe(container) {
    if (!this.swiper) {
      const t = this;
      this.swiper = new Swiper(container, {
        on: {
          slideChange: function () {
            const { realIndex } = this;
            t.setState({ currentIndex: realIndex });
          }
        },
        autoplay: { deploy: 3000, disableOnInteraction: false },
        loop: true
      });
    }
  }
  
  renderList() {
    const { events } = this.props;
    return events.map((event, idx) => {
      return (
        <div className="swiper-slide list_slide" key={idx}>
          <PortalBannerItem event={event} index={idx} />
        </div>
      )  
    });
  }
  
  render () {
    const { events } = this.props;
    
    if (!events.size) {
      return null;
    }
    
    if (events.size === 1) {
      return (
        <PortalBanner event={events.get(0)}/>
      )
    }

    return (
      <div>
        <h3 className="screen_out">슬라이드 배너</h3>
        <div className="slide_plus">
          <div className="swiper-container" ref={(ref) => { this.setSwipe(ref); }}>
            <div className="swiper-wrapper">
              { this.renderList() }
            </div>
            { this.renderPage() }
          </div>
        </div>
      </div>
    );
  }
}

PortalBannerSlide.propTypes = {
  events: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/components/PortalBannerSlide/index.js